import React, { Component } from 'react';
import { connect } from 'react-redux';
import CinemapSlider from '../../../../SHARED/components/slider/slider.component';
import { requestAllNews } from '../../../../SHARED/actions/news.actions';
import { slugify } from '../../../../SHARED/helpers/general.helper';
import Parser from 'html-react-parser';

class SliderAllNewsContainer extends Component {


    componentWillMount() {
        this.props.requestAllNews()
    }

    getSlides() {
        return this.props.allNews.map((nw, i) => {
            return {
                article_title: nw.article_title,
                article_image: Parser(nw.article_image),
                article_summary: nw.article_summary,
                item_link: `/stire/${nw.article_id}/${slugify(nw.article_title)}`
            };
        });
    }

    render() {
        const slides = this.getSlides();

        return (
            <div className="slider-recent-movies-container">
                <CinemapSlider slides={slides}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    allNews: state.news.allNews
});
export default connect(mapStateToProps, {requestAllNews})(SliderAllNewsContainer);


// WEBPACK FOOTER //
// ./src/FO/components/news/containers/sliderallnewscontainer.component.js